// Module
var code = "28, rue de Châteaudun<br/>75009 Paris - France";
// Exports
module.exports = code;